(() => {
  if (window.__colorboxLazySectionInstalled) return;
  window.__colorboxLazySectionInstalled = true;

  const state = window.__colorboxLazySection || {};

  if (!state.debug) {
    state.debug = () => {};
  }

  if (!state.parser) {
    state.parser = new DOMParser();
  }

  if (!state.reactivateScripts) {
    state.reactivateScripts = (root) => {
      root.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');

        Array.from(oldScript.attributes).forEach((attribute) => {
          newScript.setAttribute(attribute.name, attribute.value);
        });

        if (oldScript.textContent) {
          newScript.textContent = oldScript.textContent;
        }

        oldScript.replaceWith(newScript);
      });
    };
  }

  if (!state.loadSection) {
    state.loadSection = async (placeholder) => {
      if (!(placeholder instanceof HTMLElement)) {
        return;
      }

      if (placeholder.dataset.loading === 'true') {
        return;
      }

      const sectionId = placeholder.dataset.sectionId;
      const sectionWrapper = placeholder.closest('.shopify-section');

      if (!sectionId || !sectionWrapper) {
        return;
      }

      placeholder.dataset.loading = 'true';

      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', sectionId);

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to load section ${sectionId}: ${response.status}`);
        }

        const payload = await response.json();
        const html = payload && typeof payload === 'object' ? payload[sectionId] : '';

        if (!html) {
          throw new Error(`Section ${sectionId} response payload did not include the requested section.`);
        }

        const parsed = state.parser.parseFromString(html, 'text/html');
        const nextSection = parsed.querySelector('.shopify-section');

        if (!nextSection) {
          throw new Error(`Section ${sectionId} response did not include a .shopify-section wrapper.`);
        }

        sectionWrapper.replaceChildren(...document.importNode(nextSection, true).childNodes);
        state.reactivateScripts(sectionWrapper);
      } catch (error) {
        console.error('[ColorBox lazy section] Failed to load section', sectionId, error);
        placeholder.dataset.loading = 'false';
      }
    };
  }

  if (!state.observer) {
    state.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          state.observer.unobserve(entry.target);
          state.loadSection(entry.target);
        });
      },
      {
        rootMargin: '1200px 0px',
      }
    );
  }

  state.observe = () => {
    document.querySelectorAll('[data-colorbox-lazy-section]').forEach((placeholder) => {
      if (placeholder.dataset.observed === 'true') return;

      placeholder.dataset.observed = 'true';
      state.observer.observe(placeholder);
    });
  };

  window.__colorboxLazySection = state;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', state.observe, { once: true });
  } else {
    state.observe();
  }
})();
